import testVideo from "./demo.mp4";

export const checkAutoplaySupport = () => {
	return new Promise((resolve) => {
		const video = document.createElement("video");
		video.muted = true;
		video.playsInline = true;
		video.src = testVideo;

		video
			.play()
			.then(() => {
				resolve(true);
			})
			.catch(() => {
				resolve(false);
			});
	});
};

export const checkViewTransition = (fun) => {
	if ("startViewTransition" in document) {
		document.startViewTransition(() => {
			fun();
		});
	} else {
		fun();
	}
};
